module.exports = __webpack_public_path__ + "static/img/badge-larvicide-scheduled.c04557f.svg";